import * as ClassTransformer from 'class-transformer';
export var classToPlain = ClassTransformer.classToPlain;
export var classToPlainFromExist = ClassTransformer.classToPlainFromExist;
export var plainToClassFromExist = ClassTransformer.plainToClassFromExist;
export var classToClass = ClassTransformer.classToClass;
export var classToClassFromExist = ClassTransformer.classToClassFromExist;
export var serialize = ClassTransformer.serialize;
export var deserialize = ClassTransformer.deserialize;
export var deserializeArray = ClassTransformer.deserializeArray;
//# sourceMappingURL=transform.helper.js.map